import {memo, useEffect} from 'react';
import { Text } from '@amo/core/components/forms';
import { Field } from 'redux-form';
import {SmallSpinner} from "../../loaders/index.js";
import {useIban} from "../../../api/services.js";
import {required} from "../../../utils/index.js";

const IbanField =  memo(function IbanField ({necessary, formValues, changeValue, isIbanDejaClient = false}) {
    const queryIBAN = useIban(isIbanDejaClient ? undefined : formValues?.['iban']);

    const errorMessage = queryIBAN.error?.response?.data?.message;
    const errorStatus = queryIBAN.error?.status;
    const isServerError = errorStatus >= 500;  // Détecte si c'est une erreur 500 ou supérieure

    useEffect(() => {
        if(isIbanDejaClient){
            changeValue('iban', formValues?.DemandeContrat?.IBAN);
            return;
        }
        const detail = queryIBAN.data;

        if (queryIBAN.isSuccess && detail.bic) {
            changeValue('DemandeContrat[IBAN]', detail.iban);
            changeValue('DemandeContrat[BIC]', detail.bic);
            changeValue('domiciliation', detail.bank);
        } else if (queryIBAN.isError && !queryIBAN.isFetching) {
            changeValue('DemandeContrat[BIC]', '');
            changeValue('domiciliation', '');
        }
    }, [queryIBAN.isSuccess, queryIBAN.isError]);

    return (
        <div className="row">
            <div className="col-12 mt-2">
                <Field
                    name={'iban'}
                    component={Text}
                    label={'IBAN'}
                    validate={[
                        ...(necessary ? [(value) => required(value)] : []),
                        (value) => {
                            if (isIbanDejaClient) return '';
                            if (queryIBAN.isError && !queryIBAN.isFetching && !isServerError) {
                                return errorMessage;
                            }
                            if (value && (value.length < 14 || value.length > 34)) {
                                return "L'IBAN doit contenir entre 14 et 34 caractères";
                            }
                        },
                    ]}
                    /*onChange={(e) => {
                        changeValue('DemandeContrat[IBAN]', e.target.value);
                        changeValue('bic', '');
                        changeValue('domiciliation', '');
                    }}*/
                    disabled={isIbanDejaClient}
                />
                {queryIBAN.isLoading && <SmallSpinner/>}
            </div>
            {
                !isIbanDejaClient && <div className="col-12 mt-2">
                    <Field
                        name={'domiciliation'}
                        component={Text}
                        label={'Domiciliation de la banque'}
                        disabled={!isServerError}  // Activé si erreur serveur (500 ou plus)
                        normalize={(v) => v.toUpperCase()}
                        validate={[
                            ...(necessary ? [(value) => required(value)] : []),
                        ]}
                    />
                </div>
            }

            <div className="col-12 mt-2">
                <Field
                    name={'DemandeContrat[BIC]'}
                    component={Text}
                    label={'Code BIC'}
                    disabled={isIbanDejaClient || !isServerError}  // Activé si erreur serveur (500 ou plus)
                    normalize={(v) => v.toUpperCase()}
                    validate={[
                        ...(necessary ? [(value) => required(value)] : []),
                    ]}
                />
            </div>
        </div>
    );
}, (prevProps, nextProps) => {
    return prevProps.formValues === nextProps.formValues;
});

export default IbanField;
